module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('h1', {
    staticClass: "calibre29",
    attrs: {
      "id": "calibre_pb_12"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "_Toc29478519"
    }
  }, [_c('span', {
    staticClass: "calibre30"
  }, [_vm._v("Chapter Two")]), _c('br', {
    staticClass: "calibre31"
  }), _c('span', {
    staticClass: "calibre32"
  }, [_vm._v("Tokyo, Japan")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre11"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The skinny, young man known among his colleagues in the Chinese Communist Party as The Seeker, was completely accustomed to crowds, so standing across the street from Tokyo’s Shinjuku Train Station, he blended in comfortably. His physique, face, and personality were all best described as average. He had devoted his entire political life to developing this common persona, learning early in life that by lowering his profile, he lessened the threat his intellect posed to others. He believed that his greatest asset")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("was his ability to enter a room of two and not stand out. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("There were only two features that worked against this strategy. The first was his intelligent eyes that absorbed information from their surroundings. The second was his despised nickname -- The Seeker. The Second-in-Command of all China, who monitored his every move, had assigned the name as a means of insult, identifying him as someone who couldn’t be trusted. However, others used the nickname as a compliment, believing he was wise, genuinely in search of knowledge. This was the genesis of the Second-in-Command’s hatred of The Seeker.")]), _c('span', {
    staticClass: "calibre33"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("At thirty, The Seeker was already one of the ten richest men in China, and therefore the world, and the youngest high-ranking member of the Chinese Central Politburo. His power and wealth had been accrued the traditional Chinese way -- clever political intrigue and ruthless manipulation. He had been among the first to grasp the new quasi-capitalist system, quickly profiting from his investments. This marked him as a real threat to the old guard whose leader was the Second-in-Command. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Many times, he had joked with members of the Politburo that no two countries owning a McDonald’s had ever gone to war. From his perspective, his string of franchises in Taiwan, China’s mortal enemy, guaranteed peace. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("China had historically gained influence over its enemies not through war, but via financial conniving. In high-level government meetings, he consistently extolled the ancient policies of his ancestors. These same strategies had managed the Silk Roads, befriended the Persians, controlled the Mongols, influenced the Soviets, intimidated the Vietnamese, and manipulated the Indian population.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("He often challenged, “Why lose soldiers and wealth when one could simply buy another country? Why not just own the companies that make the weapons, lease the warehouses that store the military supplies, and buy up the bad mortgages of the farms that feed the soldiers?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Led by the Second-in-Command, the warmongers within the Politburo seethed whenever these questions were raised. Having no rebuttal, their anger roiled, resenting the questions that made it so difficult for them to carry out their agenda of aggression. With each winning argument, The Seeker made more enemies within the Party’s old guard. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The Seeker had recently earned one of his country’s highest military honors after signing a business deal for a string of movie theaters in, of all places, North Korea. His time in North Korea had been a bizarre experience -- surreal, frightening -- God worship gone mad. But using his unique skills to blend in, he discovered that their Great Leader loved movies, and through his myriad of contacts, he offered the Great Leader a deal that he could not pass up, thus gaining influence within North Korea. From the Chinese perspective, it was like winning the first skirmish of a long drawn out war. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Only the warmongers inside the Politburo perceived the award as a loss of face. A military honor for a business deal was unheard of and during the ceremony, The Seeker noticed men whispering. Members of the military would not, could not, tolerate this affront. Even worse, it threatened the Second-in-Command’s power base and without this support, his status in the Chinese leadership would plummet.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The Politburo had watched the Americans dismantle the Soviet Union by outspending the enemy and pushing them economically until their infrastructure collapsed — an extremely effective strategy. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Even more disconcerting to the Second-in-Command was the fact that The Chairman of all China was buying into The Seeker’s ideas. Funding to implement these new tactics for world")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("supremacy")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("would likely")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("come from what the Soviets used to call the ")]), _c('span', {
    staticClass: "calibre12"
  }, [_vm._v("Metal Eaters")]), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v(" and what the Americans still call the ")]), _c('span', {
    staticClass: "calibre12"
  }, [_vm._v("Military Industrial Complex")]), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v(", and thus weaken the Second-in-Command even further. Throughout the past year, he had grown even more frustrated and The Seeker knew that he was making an unwanted and dangerous enemy.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("And now, The Seeker found himself standing before the crush of humanity at the daunting Shinjuku Train Station. The trains of China were modern thanks to the great successes of the Central Planning Committee, but for every train that arrived at even the largest of Chinese train stations, five sped through Tokyo’s Shinjuku. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Above him, a massive HD screen towered over the population of Tokyo displaying the American movie, ")]), _c('span', {
    staticClass: "calibre12"
  }, [_vm._v("Casablanca")]), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v(". The smoke of Humphrey Bogart’s hand-rolled cigarette entwined with the soft hair of a stunning blond who gazed lovingly at Bogart’s twitching face. In Japanese, a French Resistance fighter begged for help, but Bogey just sneered and shrugged his shoulders. With all the city’s commotion, it was clear how Tokyo had earned its nickname -- The Spoiled Teenager.  The city’s psyche wanted everything -- NOW! ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Despite the slight chill of early autumn, The Seeker had removed his grey sports jacket, and realized that without meaning to, he now wore the uniform of the Japanese")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Salary Man. Scanning the streets leading to the intersection, he suppressed a grin. There stood perhaps fifty thousand men all identically dressed.  Unknowingly, he wore the perfect disguise: black pants, black shoes, and crisp white shirt.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Anonymously, he descended the stairs deep into the guts of the Shinjuku, a beast with tentacles kilometers long, its lungs breathing in and out as high-speed bullet trains, express trains, commuter trains, and uncountable subway cars came and went. Each exhale expelled a hundred thousand commuters out of the station’s internal organs and each inhale replaced them with newcomers.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Standing near a pillar, invisible in the crowd, The Seeker gathered knowledge. Unnoticed, he explored")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("underground avenues, looked into crowded stores, and watched mindless servants of the capitalist system buying meaningless trinkets. He contemplated the task that he believed righteous, the reason he was in Japan, all the while blissfully unaware of a woman from an Alexandria bookstore who was embarking on a mystery that would change everything.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre9",
    attrs: {
      "id": "calibre_pb_13"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-070456e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0000_split_005.vue
// module id = 75
// module chunks = 0